import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./utils/i18n";
import { register as registerSW } from "./utils/serviceWorkerRegistration";

const shouldInitializeSentry =
  process.env.NODE_ENV === "production" ||
  process.env.REACT_APP_ENV === "production";

if (shouldInitializeSentry) {
  Sentry.init({
    dsn: "https://4f0c1f320dd82ff59ff315edc95761d4@o4509400984584192.ingest.us.sentry.io/4509400988385280",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/api\.onbookmarks\.com\//,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Register service worker with automatic updates
registerSW();
